export const CUSTOMER_DETAILS_QUERY_KEYS = {
  TIMELINE_LOGS: "timeline_logs",
  DETAILS: "details",
  FORM_RESPONSES: "form_responses",
  COMMUNICATION_INFO: "communication_info",
};
